<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-divider>人数信息</van-divider>

            <van-cell-group>

                <van-cell
                        input-align="right"
                        title="领队"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        title="运动员"
                        :value="row.yundongyuan_count"
                />
                <van-cell
                        input-align="right"
                        title="教练员"
                        :value="row.jiaolian_count"
                />
                <van-cell
                        input-align="right"
                        title="裁判员"
                        :value="row.caipan_count"
                />
                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        label="随行人员"
                        placeholder="请选择人员"
                        @click="showFamliyPicker = true"
                />

                <FamliyPicker
                        :show="showFamliyPicker"
                        :limit="30"
                        @onChange="onFamliyChange"
                        @onClose="showFamliyPicker=false"
                        :defaultValue="formData.famliy"
                        @onConfirm="onFamliyConfirm"
                ></FamliyPicker>

                <div class="memberResultWrap" v-show="formData.famliy.length>0">
                    <div class="memberLi" v-for="(famliy ,index) in formData.famliy">
                        随行人员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                closeable
                                type="primary"
                                @close="formData.famliy.splice(index,1)"
                        > {{famliy.name}} {{famliy.num}}
                        </van-tag>
                    </div>

                    <div style="line-height: 28px; padding-top: 10px; font-size: 14px; text-align: center ; color: #666">
                        跟大会安排并缴费食宿费和餐车费的随行家长需添加身份证信息，若全程不跟大会，请勿添加。<br/>
                      </div>
                </div>



            </van-cell-group>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">下一步</van-button>
            </div>
        </van-form>



    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
            CaipanPicker,
            JiaolianPicker,
            FamliyPicker,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row:{

                },
                formData: {
                    id: 0,
                    famliy:[],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onFamliyConfirm(values){
                console.log('onFamliyConfirm',values)
                this.showFamliyPicker = false;
                this.formData.famliy = [...values];
            },
            onFamliyChange(values){
                console.log('onYundongyaunChange',values)
                this.formData.famliy = [...values];
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/sai/famliysave', that.formData, (res) => {
                    that.saveLoading = false;
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/sai/step3detail', {
                    id:that.formData.id
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep3.vue?1c630f52